<template>
  <div v-if="media">
    <b-link :disabled="disabled"
            class="nav-link icon-share"
            @click.prevent="download()"
            v-if="quality === mediaQuality.AUTO">
      <div class="icon-bg">
        <b-spinner v-if="loading" small />
        <Icon name="download" width="26" v-else/>
      </div>
    </b-link>
    <b-button variant="primary" block v-else
              class="position-relative"
              :class="{'disabled': disabled}"
              @click="download()">{{ label }}
    </b-button>
  </div>
</template>

<script>
import metric_message from "@/domain/metrics/message";
import {mediaQuality, mediaTypes, servingType} from "@/domain/galleries/constants";
import {mapGetters} from "vuex";

export default {
  emits: ['click'],
  data() {
    return {
     loading: false
    }
  },
  props: {
    quality: {
      type: String,
      required: true
    },
    media: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('checkinDetail', [
      'hdServingType'
    ]),
    disabled() {
      return !this.mediaUrl
    },
    mediaQuality() {
      return mediaQuality;
    },

    mediaUrl() {
      if (this.quality === mediaQuality.AUTO) return this.media.download_hd_url || this.media.download_sd_url

      if (this.quality === mediaQuality.SD) {
        if (this.media.media_type === mediaTypes.VIDEO) {
          return this.media.download_hd_url || this.media.video_preview_url || this.media.download_sd_url
        }
        return this.media.download_sd_url
      } else if (this.quality === mediaQuality.HD) {
        if (this.media.download_hd_url) {
          return this.media.download_hd_url.includes('cdn.getpica.com') ? `${this.media.download_hd_url}/download` : this.media.download_hd_url
        }
        return null
      }
      return null
    },

    label() {
      if (this.quality === mediaQuality.SD) {
        if (this.hdServingType === servingType.DISABLED || !this.media.download_hd_url) {
          return this.$t('collage_photo_item.download')
        }
        return this.$t('collage_photo_item.sd_size')
      } else {
        if (!this.mediaUrl && this.hdServingType !== servingType.DISABLED) {
          return this.$t('collage_photo_item.download_hd_available_from')
        }
        return this.media.download_sd_url
            ? this.$t('collage_photo_item.hd_size')
            : this.$t('collage_photo_item.download')
      }
    }
  },

  methods: {
    canNativeShare() {
      return typeof navigator.share === 'function'
        && /iPhone|iPad/i.test(navigator.userAgent)
    },

    async download() {
      if (this.disabled) return
      this.loading = true
      metric_message.photoDownloaded(this.media.id, this.media.media_type === mediaTypes.VIDEO)
      this.$emit('click')

      if (this.canNativeShare()) {
        await this.nativeShare()
      } else {
        location.href = this.mediaUrl
        await this.wait(1000)
      }

      this.loading = false
      return false
    },

    async nativeShare() {
      try {
        const response = await fetch(this.mediaUrl, { method: 'GET', mode: 'cors' })
        const blob = await response.blob()
        const extension = this.media.media_type === mediaTypes.VIDEO ? 'mp4' : 'jpg'
        const mimeType = this.media.media_type === mediaTypes.VIDEO ? 'video/mp4' : 'image/jpeg'
        const file = new File([blob], `media_${this.media.id}.${extension}`, { type: mimeType })

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file] })
        } else {
          location.href = this.mediaUrl
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          location.href = this.mediaUrl
        }
      }
    },
  }
}
</script>